import { render, staticRenderFns } from "./fixedBottomPanel.vue?vue&type=template&id=ca2df0dc&scoped=true&"
import script from "./fixedBottomPanel.vue?vue&type=script&lang=js&"
export * from "./fixedBottomPanel.vue?vue&type=script&lang=js&"
import style0 from "./fixedBottomPanel.vue?vue&type=style&index=0&id=ca2df0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2df0dc",
  null
  
)

export default component.exports